(function ($)
{
	window.Country = function (CountryID, Color, Symbols)
	{
		this.InputData = {
			CountryID: CountryID || "",
			Color: Color || "",
			Symbols: Symbols || []
		};

		this.OutputData = {};
	};

	Country.fn = Country.prototype;

	// passes back the exact OutputData object that is stored
	Country.fn.GetOutputData = function ()
	{
		return this.OutputData;	
	};

	// passes back the InputData object that is stored.
	// there are 2 flavors and they are determined by passing in a boolean
	// @ bReferenceData = bool
	// bReferenceData determines whether you receive the object in its pure form
	// which means all the properties and symbols is an array of pointers to the
	// "symbol" type/class. If bReferenceData does not exist or is null or false
	// then you will receive the InputData object with all the properties and
	// InputData.Symbols will be an array of InputData from each symbol class/type.
	// passing false is good for sending ajax calls, but if you want to manipulate references
	// pass true.
	Country.fn.GetInputData = function (bReferenceData)
	{
		if (bReferenceData)
		{
			return this.InputData;
		}
		else
		{
			var objToReturn = {
				CountryID: this.InputData.CountryID,
				Color: this.InputData.Color,
				Symbols: []
			};

			for (var i = 0, j = this.InputData.Symbols.length; i < j; i++)
			{
				objToReturn.Symbols.push(this.InputData.Symbols[i].GetInputData());
			}

			return objToReturn;
		}
	};

	// allows you to add a type/class of Symbol to the InputData.Symbols array.
	Country.fn.AddSymbol = function (objSymbol)
	{
		if (!objSymbol) { throw ("Symbol object cannot be null. Check your inputs and try again"); }

		if (!objSymbol.InputData.WsodIssue || !objSymbol.InputData.months)
		{
			throw ("WsodIssue and months are required inputs. Check your inputs and try again");
		}

		this.InputData.Symbols.push(objSymbol);

		return this; // let it chain, let it chain, let it chain
	};

	// allows you to remove a specific symbol class from the array if you pass a matching WSODIssue
	//
	// Examples:
	// Remove 1
	//
	// myCountry.RemoveSymbol(123456)
	// Remove 1 or Many
	//
	// myCountry.RemoveSymbol(123456, 78910, 1112131415)
	Country.fn.RemoveSymbol = function ()
	{
		var iSymbolsLength = this.InputData.Symbols.length;

		var objIndexesToRemove = {};

		var arNewSymbols = [];

		for (var i = 0, j = arguments.length; i < j; i++)
		{
			var identifier = arguments[i];

			if (!identifier) { continue; } // no need to mess with nulls

			for (var it = 0; it < iSymbolsLength; it++)
			{
				var objSymbol = this.InputData.Symbols[it];

				if (identifier == objSymbol.WsodIssue)
				{
					objIndexesToRemove[it.toString()] = true;
				}
			}
		}

		for (var i = 0; i < iSymbolsLength; i++)
		{
			if (!objIndexesToRemove[i.toString()])
			{
				arNewSymbols.push(this.InputData.Symbols[i]);
			}
		}

		this.InputData.Symbols = arNewSymbols;

		return this; // let it chain, let it chain, let it chain
	};
})(jQuery);